<template lang="pug">
.form-group
  label.control-label(v-if='fieldLabel') {{ fieldLabel }}
    span(v-if='required') &nbsp*
  checkbox(v-for='(option, index) in options'
          v-model='value'
          :name='name'
          :key='index'
          :option-index='index'
          :option-label='option.label || option'
          :option-status='option.status')
</template>

<script>
import Checkbox from './checkbox.vue'

export default {
  name: 'ed-checkbox',
  props: {
    value: String,
    options: Array,
    fieldLabel: String,
    name: String,
    disabled: Boolean,
    required: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'checkbox': Checkbox
  }
}
</script>

<style lang="scss">
@import "~@/assets/sass/_variables.scss"; 

// Checkbox

</style>



// WEBPACK FOOTER //
// index.vue?5fa8a988